import React from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { sepResolve } from '@separate/utilities/routes';

let handled = false;

export default function Custom200() {
  const { replace, asPath } = useRouter();

  React.useEffect(() => {
    if (handled || !replace) return;

    const pathname = window.WelcomeTech?.originalPathname || '';
    console.log("Inside of 200 file, original location = ", pathname);
    const locale = pathname.startsWith('/en/') ? 'en' : 'es';

    handled = true;

    const path = asPath;

    const resultingPath = sepResolve(path, locale);
    replace(resultingPath);
  }, [replace, asPath]);

  return null;
}
